/**
 * Allowed email domains for Google directory validation (mirrors backend
 * colleagueDirectoryEmailService allowedWorkspaceDomains / isAllowedTargetEmail).
 */
export function allowedWorkspaceDomains(fallbackDomain = 'creativedock.com'): string[] {
  const raw =
    import.meta.env.VITE_ALLOWED_DOMAINS ||
    import.meta.env.VITE_ALLOWED_DOMAIN ||
    fallbackDomain;
  return raw
    .split(',')
    .map((d) => d.trim().toLowerCase())
    .filter(Boolean);
}

export function isAllowedWorkspaceEmail(email: string, fallbackDomain = 'creativedock.com'): boolean {
  const at = email.lastIndexOf('@');
  if (at <= 0) return false;
  const domain = email.slice(at + 1).toLowerCase();
  return allowedWorkspaceDomains(fallbackDomain).includes(domain);
}
